import styled from 'styled-components'

import { mq, pxToRem, sizes } from '../../theme'
import FormikForm from '../../form/FormikForm'
import Icon from '../Icon'
import FilterCheck from '../../form/FilterCheck'

export const Container = styled.div``
// SEARCH
export const _FormikForm = styled(FormikForm)`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(40)};
  @media ${mq(sizes.desktop)} {
    display: flex;
    flex-flow: row nowrap;
  }
`
export const Search = styled.div`
  align-self: flex-start;
  display: grid;
  grid-template-columns: [field] 1fr [reset] auto [submit] auto;
  align-items: center;
  gap: ${pxToRem(16)};
  min-height: ${pxToRem(64)};
  border: 1px solid rgba(0, 0, 0, 0.3);
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  transition: border-color 0.3s ease-in-out;
  &:hover {
    border-color: rgba(0, 0, 0, 0.5);
  }
  &:focus-within {
    border-color: rgba(0, 0, 0, 1);
  }
  @media ${mq(sizes.desktop)} {
    flex: 0 0 auto;
    width: ${pxToRem(312)};
  }
`
export const Placeholder = styled.label`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 3;
  grid-column: field / span 1;
  grid-row: 1;
  width: fit-content;
  margin-inline-start: ${pxToRem(8)};
  padding-inline: ${pxToRem(8)};
  color: rgba(0, 0, 0, 0.5);
  background: ${({ theme }) => theme.colors.white};
  transition:
    transform 0.3s linear,
    font-size 0.3s linear;
  input:focus ~ &,
  input:not(:placeholder-shown) ~ & {
    transform: translate3D(0, ${pxToRem(-32)}, 0);
    font-size: 0.75em;
  }
`
export const Input = styled.input.withConfig({
  shouldForwardProp: (prop) => prop !== 'hasError' && prop !== 'error',
})`
  ${({ theme }) => theme.textStyles.d1440_body}
  position: relative;
  z-index: 1;
  grid-column: field / span 1;
  grid-row: 1;
  align-self: stretch;
  margin-inline-start: ${pxToRem(16)};
  margin-block: 1px;
  background-color: transparent;
  border: none;
  &:focus,
  &:focus-visible {
    outline: unset;
  }
  &::placeholder {
    color: transparent;
  }
  &::placeholder {
    color: transparent;
  }
  &::-ms-clear {
    display: none;
  }
  &::-webkit-search-cancel-button {
    display: none;
  }
`
export const Reset = styled.button`
  position: relative;
  z-index: 2;
  grid-column: reset / span 1;
  grid-row: 1;
  display: flex;
  background: unset;
  transition:
    opacity 0.15s ease-in-out,
    visibility 0s 0s;
  input:placeholder-shown ~ & {
    opacity: 0;
    pointer-events: none;
    visibility: hidden;
    transition:
      opacity 0.15s ease-in-out,
      visibility 0s 0.15s;
  }
`
export const ResetIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(16)};
`
export const Submit = styled.button`
  position: relative;
  z-index: 2;
  grid-column: submit / span 1;
  grid-row: 1;
  display: flex;
  margin-inline-end: ${pxToRem(16)};
  background: unset;
`
export const SubmitIcon = styled(Icon)`
  flex: 0 0 auto;
  aspect-ratio: 1;
  width: ${pxToRem(24)};
`
// FILTER
export const Filters = styled.fieldset`
  width: 100%;
  flex: 0 1 auto;
  display: flex;
  flex-flow: column;
  gap: ${pxToRem(24)};
  margin: unset;
  border: unset;
  padding: unset;
  @media ${mq(sizes.desktop)} {
    flex-flow: row nowrap;
    align-items: flex-start;
    gap: ${pxToRem(40)};
    margin-inline-start: auto;
    max-width: calc(100% * 2 / 3);
  }
`
export const FiltersLegend = styled.legend`
  ${({ theme }) => theme.textStyles.m375_body}
  float: left;
  display: flex;
  align-items: center;
  min-height: ${pxToRem(38)};
  padding: unset;
  @media ${mq(sizes.desktop)} {
    ${({ theme }) => theme.textStyles.d1440_body}
    white-space: nowrap;
  }
`
export const FiltersContent = styled.div`
  display: flex;
  flex-flow: row wrap;
  gap: ${pxToRem(12)};
`
export const _FilterCheck = styled(FilterCheck)``
